import React, {useContext, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {
  isAuthenticatedContext,
  userInfosContext,
} from "../../contexts/authContext";
import {url} from "./CardItem";

const Menu = () => {
  const {id} = useParams();

  const [menu, setMenu] = useState();
  const [author, setAuthor] = useState();
  const [comment, setComment] = useState();
  const [formSuccess, setFormSuccess] = useState();
  const [comments, setComments] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const isAuthenticated = useContext(isAuthenticatedContext);
  const userInfos = useContext(userInfosContext);

  // const FormComment = async (e) => {
  //     e.preventDefault();
  //    // setAuthor(userInfos.username);
  //     await fetch(`${url}/comments`, {
  //         method: "POST",
  //         headers: {
  //             "Content-Type": "application/json",
  //             'Authorization': 'Bearer ' + userInfos.token
  //         },
  //         body: JSON.stringify({author: userInfos.username, comment, menu: menu.id}),
  //     })
  //         .then((res) => {
  //             console.log(res);
  //             if (res.status === 200) {
  //                 setFormSuccess(true);
  //             }
  //         })
  //         .catch((err) => console.error(err));
  // };

  const fetchMenu = () => {
    fetch(`${url}/menus/${id}`)
      .then((res) => res.json())
      .then((res) => {
        setMenu(res);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchMenu();
  }, []);

  return (
    <div>
      {isLoading ? (
        <div className='m-auto'>Chargement ...</div>
      ) : (
        <div className='grid grid-cols-1'>
          <div className='mx-10 mt-32'>
            <article className='overflow-hidden rounded-lg shadow-lg'>
              <div>
                <img
                  alt='Placeholder'
                  className='block h-auto w-full'
                  src={menu.picture}
                />
              </div>

              <header className='flex items-center justify-between leading-tight p-2 md:p-4'>
                <h1 className='text-lg'>
                  <a
                    className='no-underline hover:underline text-black'
                    href='#'>
                    {menu.name}
                  </a>
                </h1>
              </header>
              <p className='text-gray-500 text-sm ml-3'>{menu.ingredients}</p>

              <footer className='leading-none p-2 md:p-4'>
                <p className='text-right'>
                  Menu {menu.priceinMenu}/Seul {menu.pricealacarte}€
                </p>
              </footer>
            </article>
          </div>
          <div className='m-12 grid grid-rows-2 gap-4'>
            {isAuthenticated && userInfos.username !== "Pseudo" && (
              <div>Achat.</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Menu;
